const RevenueOverview = () => {
    return (
        <div className="dashboard-card">
            <h2>Revenue Overview</h2>

            <div className="finance-overview-grid">
                <div>
                    <h4>Today</h4>
                    <h3>₹34,500</h3>
                </div>

                <div>
                    <h4>This Week</h4>
                    <h3>₹1,92,000</h3>
                </div>

                <div>
                    <h4>This Month</h4>
                    <h3>₹8,42,500</h3>
                </div>

                <div>
                    <h4>This Year</h4>
                    <h3>₹78,30,000</h3>
                </div>
            </div>
        </div>
    );
};

export default RevenueOverview;
